import { Card } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionWinRecords } from './SectionWinRecords';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';

export default function BlindBoxWinRecordsList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-win-records" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.winRecords')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.winRecords') },
          ]}
        />
        <Card variant="outlined" sx={{ ...SECTION_CARD_SX, mt: 2 }}>
          <SectionWinRecords refreshKey={refreshKey} />
        </Card>
      </DashboardContent>
    </PermissionGuard>
  );
}
